import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["quickLoginFrom", "quickLoginTo", "loginFrom", "loginTo"]

  applyToAll() {
    const loginFromValue = this.quickLoginFromTarget.value
    const loginToValue = this.quickLoginToTarget.value

    if (!loginFromValue || !loginToValue) {
      $.notify("Please select both login from and login to times", "error")
      return
    }

    let appliedCount = 0

    this.loginFromTargets.forEach((select) => {
      this.setSelectValueAndTrigger(select, loginFromValue)
      appliedCount++
    })

    this.loginToTargets.forEach((select) => {
      this.setSelectValueAndTrigger(select, loginToValue)
    })

    if (appliedCount > 0) {
      $.notify(`Login times applied to all ${appliedCount} day(s). Please click on save settings button to apply the changes`, "success")
    } else {
      $.notify("No days found to apply settings to", "info")
    }
  }

  setSelectValueAndTrigger(select, value) {
    select.value = value
    const event = new Event('change', { bubbles: true })
    select.dispatchEvent(event)
    if (typeof $ !== 'undefined') {
      $(select).trigger('change')
    }
  }
}
